import React from 'react';
import { Table, TableBody, TableContainer } from '@mui/material';
import CampaignRow from './CampaignRow';
import OverviewFooter from './OverviewFooter';
import OverviewHeader from './OverviewHeader';
import { useMemo } from 'react';
import { useTableSort, sortData } from '../../../utils/tableSorting';

function CampaignOverviewTable(props) {
    const { order, orderBy, handleRequestSort } = useTableSort('start_date', 'desc');

    const visibleRows = useMemo(() => {
        const filteredCampaigns = props.campaigns.filter((campaign) => {
            return Object.entries(props.appliedFilters).every(([filterName, filterInfo]) => {
                if (!filterInfo.selected) {
                    return true;
                }
                if (filterName === 'Specialties') {
                    return filterInfo.selectedOptions.some((option) => campaign.specialties.includes(option));
                }
                return filterInfo.selectedOptions.includes(campaign[filterName.toLowerCase()]);
            });
        });
        return sortData(filteredCampaigns, order, orderBy);
    }, [order, orderBy, props.campaigns, props.appliedFilters]);

    function handleCheckboxChange(campaignId) {
        const newSelectedCampaigns = new Set(props.selectedCampaigns);
        if (newSelectedCampaigns.has(campaignId)) {
            newSelectedCampaigns.delete(campaignId);
        } else {
            newSelectedCampaigns.add(campaignId);
        }
        props.setSelectedCampaigns(newSelectedCampaigns);
    }

    function handleSelectAllCampaigns(event) {
        const isChecked = event.target.checked;
        const newSelectedCampaigns = isChecked ? new Set(visibleRows.map(campaign => campaign.id)) : new Set();
        props.setSelectedCampaigns(newSelectedCampaigns);
    }

    return (
        <TableContainer sx={{ borderRadius: '8px', border: '2px solid #DDD', backgroundColor: 'white', overflow: 'auto' }}>
            <Table stickyHeader>
                <OverviewHeader
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    isAllSelected={props.selectedCampaigns.size === visibleRows.length && visibleRows.length > 0}
                    isIndeterminate={props.selectedCampaigns.size > 0 && props.selectedCampaigns.size < visibleRows.length}
                    onSelectAll={handleSelectAllCampaigns}
                />
                <TableBody>
                    { visibleRows.map((campaign) => (
                        <CampaignRow 
                            key={campaign.id} 
                            campaign={campaign} 
                            isSelected={props.selectedCampaigns.has(campaign.id)} 
                            handleSelect={() => handleCheckboxChange(campaign.id)}
                        />
                    ))}
                </TableBody>
                <OverviewFooter selectedCampaigns={props.selectedCampaignObjects} visibleCampaigns={visibleRows} totalCampaigns={props.campaigns.length} />
            </Table>
        </TableContainer>
    );
}

export default CampaignOverviewTable;
